import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaLinkedin, FaInstagram, FaTiktok } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="footer">
        <div className="site-footer-brand">
          <Link to="/" aria-label="Exhibirte - Inicio">
            <img src="/LogoExhibirte.png" alt="Exhibirte" />
          </Link>
          <nav className="site-footer-socials" aria-label="Redes sociales de Exhibirte">
            <a href="https://www.linkedin.com/company/exhibirte-stands-carteler%C3%ADa-y-comunicaci%C3%B3n-visual/posts/" target="_blank" rel="noopener noreferrer" aria-label="Exhibirte en LinkedIn">
              <FaLinkedin aria-hidden="true" /><span>LinkedIn</span>
            </a>
            <a href="https://www.instagram.com/exhibirte/?hl=es-la" target="_blank" rel="noopener noreferrer" aria-label="Exhibirte en Instagram">
              <FaInstagram aria-hidden="true" /><span>Instagram</span>
            </a>
            <a href="https://www.tiktok.com/@exhibirte" target="_blank" rel="noopener noreferrer" aria-label="Exhibirte en TikTok">
              <FaTiktok aria-hidden="true" /><span>TikTok</span>
            </a>
          </nav>
        </div>
        <address className="site-footer-contact">
          <a href={`mailto:${t('footer.email')}`}><FaEnvelope aria-hidden="true" /> {t('footer.email')}</a>
          <a href="tel:+59895732636"><FaPhoneAlt aria-hidden="true" /> {t('footer.phone')}</a>
          <span><FaMapMarkerAlt aria-hidden="true" /> {t('footer.address')}</span>
        </address>
        <nav className="site-footer-navigation" aria-label="Navegación del pie de página">
          <span>Navegación</span>
          <Link to="/">{t('nav.home')}</Link>
          <Link to="/alquiler-mobiliario-eventos">{t('nav.furniture')}</Link>
          <Link to="/proyectos">{t('nav.projects')}</Link>
          <Link to="/clientes">{t('nav.clients')}</Link>
          <Link to="/nosotros">{t('nav.about')}</Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;

